import Styles from './styles.module.scss';

interface Props {
	text: string | number;
	isBold?: boolean;
	isDark?: boolean;
}

export const TextCell = ({ text, isBold = false, isDark = false }: Props) => {
	return (
		<div className={Styles.textCellContainer}>
			<span className={isBold ? Styles.bold : isDark ? Styles.dark : ''}>{text}</span>
		</div>
	);
};
